<pw-view-title *ngIf="mode === 'snr'">
  {{'change.prismaImport.importSnr' | translate}}
</pw-view-title>

<pw-view-title *ngIf="mode === 'doc'">
  {{'change.prismaImport.importDocuments' | translate}}
</pw-view-title>
<div style="display: flex; flex-direction: column">

  <mat-form-field *ngIf="mode==='snr'">
    <mat-label>{{'change.prismaImport.itemNumber' | translate}}</mat-label>
    <input matInput [(ngModel)]="snr"/>
  </mat-form-field>

  <table mat-table [dataSource]="dataSource" matSort
         matSortActive="INDEX_ZI" matSortDirection="desc">

    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox (change)="$event ? masterToggle() : null"
                      [checked]="selection?.hasValue() && isAllSelected()"
                      [indeterminate]="selection?.hasValue() && !isAllSelected()">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox (click)="$event.stopPropagation()"
                      (change)="$event ? selection.toggle(row) : null"
                      [checked]="selection.isSelected(row)">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="DOKU_REIFE">
      <th mat-header-cell *matHeaderCellDef> {{'change.prismaImport.docMaturity' | translate}}</th>
      <td mat-cell *matCellDef="let element"> {{element.DOKU_REIFE}} </td>
    </ng-container>

    <ng-container matColumnDef="INDEX_AI">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'change.prismaImport.ai' | translate}}</th>
      <td mat-cell *matCellDef="let element"> {{element.INDEX_AI}} </td>
    </ng-container>

    <ng-container matColumnDef="DOKU_TYP">
      <th mat-header-cell *matHeaderCellDef> {{'change.prismaImport.docType' | translate}}</th>
      <td mat-cell *matCellDef="let element"> {{element.DOKU_TYP}} </td>
    </ng-container>

    <ng-container matColumnDef="SNR">
      <th mat-header-cell *matHeaderCellDef> {{'change.prismaImport.docItemNumber' | translate}}</th>
      <td mat-cell *matCellDef="let element"> {{element.SNR}} </td>
    </ng-container>

    <ng-container matColumnDef="SNR_DESCR">
      <th mat-header-cell *matHeaderCellDef> {{'change.prismaImport.docItemNumberDesc' | translate}}</th>
      <td mat-cell *matCellDef="let element"> {{element.SNR_DESC}} </td>
    </ng-container>

    <ng-container matColumnDef="INDEX_ZI">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'change.prismaImport.docItemNumberZi' | translate}}</th>
      <td mat-cell *matCellDef="let element"> {{element.INDEX_ZI}} </td>
    </ng-container>

    <ng-container matColumnDef="DOKU_FORMAT">
      <th mat-header-cell *matHeaderCellDef> {{'change.prismaImport.docFormat' | translate}}</th>
      <td mat-cell *matCellDef="let element"> {{element.DOKU_FORMAT}} </td>
    </ng-container>

    <ng-container matColumnDef="REIFE">
      <th mat-header-cell *matHeaderCellDef> {{'change.prismaImport.maturity' | translate}}</th>
      <td mat-cell *matCellDef="let element"> {{element.REIFE}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"
        (click)="selection.toggle(row)">
    </tr>
  </table>

  <mat-paginator [pageSizeOptions]="[5, 10, 20]" [pageSize]="10" aria-label="Pagesize"></mat-paginator>

  <div style="padding-top: 12px; justify-content: flex-end; display: flex; gap: 12px">
    <button mat-raised-button color="primary" *ngIf="mode === 'snr'" [disabled]="!snr" (click)="requestDocuments()">
      {{'change.prismaImport.loadDocuments' | translate}}
    </button>
    <button mat-raised-button color="primary" *ngIf="mode === 'doc'" [disabled]="!selection?.hasValue()"
            (click)="importDocuments()">
      {{'change.prismaImport.importDocs' | translate}}
    </button>
    <button mat-raised-button color="primary" *ngIf="mode === 'snr'" [disabled]="!selection?.hasValue()"
            (click)="importSnr()">
      {{'change.prismaImport.importIndexNumber' | translate}}
    </button>
  </div>
</div>

